"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author JMr
 */


var PriceArchitectureExportDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceArchitectureExportDTOConverter, _DataObjectConverter_);

  function PriceArchitectureExportDTOConverter() {
    _classCallCheck(this, PriceArchitectureExportDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceArchitectureExportDTOConverter).apply(this, arguments));
  }

  return PriceArchitectureExportDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceArchitectureExportDTOConverter = PriceArchitectureExportDTOConverter;